module.exports = __webpack_public_path__ + "img/w3_circle_grid_light.84969b00.84969b00.png";